import { LockedBlurredListOverlay, LockedEmptyUpsell } from '../../../../lumpsum/plans-list/body/shared/LockedPlanPieces'
import { PlansScreen } from '../../../../analytics/plansEvents'
import { useSipPlansContext } from '../../SipPlansProvider'
import { YourPlanCategoryList } from './YourPlanCategoryList'
import { SIP_YOUR_PLAN_BLURRED_CATEGORIES } from '../../../../../mock/data/blurFixtures'

/** PLAN_ROLLED_OUT but not Prime. */
export function SipYourPlanBlurredBody() {
  const { derivedPlans } = useSipPlansContext()
  const yourPlanCategories = derivedPlans?.yourPlanCategories ?? []
  const hasLockedListContent = yourPlanCategories.some((category) => {
    const stopCount = category?.stopRecommendations?.length ?? 0
    const startCount = category?.startRecommendations?.length ?? 0
    const increaseCount = category?.increaseRecommendations?.length ?? 0
    const decreaseCount = category?.decreaseRecommendations?.length ?? 0
    return stopCount + startCount + increaseCount + decreaseCount > 0
  })

  if (!hasLockedListContent) {
    return (
      <LockedEmptyUpsell
        copy="Get Allocation Plan, SIP Plan, Rebalance Plan,<br />Where to invest, Power Rank, Trends and a lot more."
        buttonLabel="Unlock with Elite Prime"
        landingPage="prime"
        analyticsScreen={PlansScreen.SipYourPlan}
      />
    )
  }

  return (
    <LockedBlurredListOverlay
      message={
        <>
          Your SIP plan is
          <br />
          currently locked
        </>
      }
      buttonLabel="Unlock with Prime"
      landingPage="prime"
      analyticsScreen={PlansScreen.SipYourPlan}
    >
      <YourPlanCategoryList categories={SIP_YOUR_PLAN_BLURRED_CATEGORIES} />
    </LockedBlurredListOverlay>
  )
}
